import 'what-input'
import a11y from './a11y'

import backToTop from './components/back-to-top'
import statistics from './components/statistics'
import TableLoadMore from './components/TableLoadMore'
import FilterBar from './components/FilterBar'
import sliders from './components/sliders'
import Animations from './components/Animations'
import glightbox from './components/glightbox'

import domready from './vendors/domready.js'
import targetBlankAdder from './libs/target-blank-adder'

import MainHeader from './components/MainHeader/index.js'
import MainNavigation from './components/MainNavigation/index.js'
import SecondaryNavigation from './components/SecondaryNavigation/index.js'

import AirQualitySummary from './components/AirQuality/tab-summary.js'
import AirQualityMeasurements from './components/AirQuality/tab-measurements.js'

import ScrollBarCustom from './components/ScrollBarCustom/index.js'

import Parkings from './components/Parkings/index.js'
import Places from './components/Places/index.js'
import Tabs from './components/Tabs/index.js'

import table from './components/table/index.js'
import tooltip from './components/tooltip/index.js'
import GravityForm from './components/GravityForm/index.js'
import CruiseShipMap from './components/CruiseShipMap/index.js'

domready(() => {
  targetBlankAdder()
  a11y()
  statistics()
  backToTop()
  sliders()
  glightbox()
  table()
  tooltip()
  GravityForm()
  ScrollBarCustom()

  new FilterBar()
  new MainHeader()
  new TableLoadMore()
  new Animations()

  document.querySelectorAll('.js-header-toggle').forEach((element) => {
    new MainNavigation(element)
  })

  document
    .querySelectorAll('.main-navigation .js-menu-toggle')
    .forEach((element) => {
      new MainNavigation(element)
    })

  document
    .querySelectorAll('.secondary-navigation .js-menu-toggle')
    .forEach((element) => {
      new SecondaryNavigation(element)
    })

  document.querySelectorAll('[role=tablist].automatic').forEach((element) => {
    new Tabs(element)
  })

  document.querySelectorAll('.js-air-quality-tabs').forEach((element) => {
    new AirQualitySummary(element)
    new AirQualityMeasurements(element)
  })
})

window.initParkingsMap = () => new Parkings()
window.initPlacesMap = () => new Places()
window.initCruiseShipMap = () => CruiseShipMap()
